'use client';

import React from 'react';

import useCookieConsent from '@cineamo/ui/src/hooks/useCookieConsent';

/**
 * Renders its children only once the visitor has opted into `cookieName` (CIN-14856, § 25 TDDDG).
 *
 * A client component on purpose, even though both call sites are server components: the public
 * pages are HTML-cached upstream of Next.js, so the server output must not branch on a cookie.
 * `useCookieConsent` denies on the first render and reacts to a banner change without a reload.
 */
export default function ConsentGate({
    cookieName,
    children
}: Readonly<React.PropsWithChildren<{ cookieName: string }>>): React.JSX.Element | null {
    return useCookieConsent(cookieName) ? <>{children}</> : null;
}
